import { SvgIcon, type SvgIconProps } from './svgIcon'

export function WalletIcon({
  width = 20,
  height = 21,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M1.41 4.02V16.36C1.41 18.03 2.75999 19.38 4.42999 19.38H19.06V7.04H4.42999C2.75999 7.04 1.41 5.69 1.41 4.02ZM1.41 4.02C1.41 2.35 2.75999 1 4.42999 1H16.73V7.05"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}
